import { createStore } from "zustand-x";

type AuthStore = {
  token: string | null;
  getToken?: () => Promise<string>;
};

const useAuthStore = createStore<AuthStore>(
  {
    token: null,
    getToken: undefined,
  },
  {
    name: "AuthStore",
  }
);

// Store actions for direct usage
export const authActions = {
  setGetToken: (fn: () => Promise<string>) => {
    useAuthStore.store.setState({ getToken: fn });
  },
};

export default useAuthStore;
